import { useState, useEffect } from "react";

const DESKTOP_MIN_WIDTH = 768;

/**
 * Tracks viewport ≥768px (apps/web CLAUDE.md rule: mobile-first under 768).
 * Reactive to resize (useful when DevTools toggle viewport, or rotate).
 */
export function useIsDesktop(): boolean {
  const [desktop, setDesktop] = useState(
    () =>
      typeof window !== "undefined" &&
      window.matchMedia(`(min-width: ${DESKTOP_MIN_WIDTH}px)`).matches,
  );
  useEffect(() => {
    const mq = window.matchMedia(`(min-width: ${DESKTOP_MIN_WIDTH}px)`);
    const on = () => setDesktop(mq.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return desktop;
}
